import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { GoalsSection } from '../components/GoalsSection';
import { TemplatesCarousel } from '../components/TemplatesCarousel';
import { KitContentsSection } from '../components/KitContentsSection';
import { ResultsSection } from '../components/ResultsSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function LandingPage() {
  return <main className="w-full overflow-hidden" data-id="element-208">
      <HeroSection data-id="element-209" />
      <ProblemSection data-id="element-210" />
      <GoalsSection data-id="element-211" />
      <TemplatesCarousel data-id="element-212" />
      <KitContentsSection data-id="element-213" />
      <ResultsSection data-id="element-214" />
      <BeforeAfterSection data-id="element-215" />
      <OfferSection data-id="element-216" />
      <GuaranteeSection data-id="element-217" />
      <FinalCtaSection data-id="element-218" />
    </main>;
}